import React from "react";
import { Link } from "react-router-dom";

export default function PaiementsEncadresDemoPage() {
  return (
    <div style={styles.page}>

      {/* RETOUR */}
      <Link to="/" style={styles.back}>← Retour</Link>

      {/* CARD */}
      <div style={styles.card}>

        {/* ANIMATION */}
        <div style={styles.orbit}>
          <div style={{...styles.phone, ...styles.android}}>Android</div>
          <div style={{...styles.phone, ...styles.ios}}>iOS</div>
          <div style={styles.shield}>🔒</div>
        </div>

        {/* TEXTE */}
        <h1 style={styles.title}>Paiements encadrés</h1>

        <p style={styles.subtitle}>
          Une logique pensée pour Android, iOS et les règles des plateformes.
        </p>

        {/* FLOW */}
        <div style={styles.steps}>
          <span style={styles.step}>Achat coins</span>
          <span style={styles.step}>Validation plateforme</span>
          <span style={styles.step}>Solde sécurisé</span>
        </div>

      </div>

      {/* KEYFRAMES INLINE */}
      <style>{`
        @keyframes rotateOrbit {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes pulseShield {
          0%,100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }
      `}</style>

    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "radial-gradient(circle at top, #072b36, #020407 70%)",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    overflow: "hidden",
    position: "relative"
  },

  back: {
    position: "fixed",
    top: "20px",
    left: "20px",
    color: "#00f2ff",
    textDecoration: "none",
    fontWeight: "700"
  },

  card: {
    width: "100%",
    maxWidth: "900px",
    textAlign: "center",
    padding: "40px 20px",
    borderRadius: "30px",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(0,242,255,0.25)",
    boxShadow: "0 0 40px rgba(0,242,255,0.2)"
  },

  orbit: {
    position: "relative",
    width: "280px",
    height: "280px",
    margin: "0 auto 30px",
    borderRadius: "50%",
    border: "1px dashed rgba(0,242,255,0.4)",
    animation: "rotateOrbit 12s linear infinite"
  },

  phone: {
    position: "absolute",
    width: "100px",
    height: "160px",
    borderRadius: "20px",
    background: "linear-gradient(180deg,#111,#050505)",
    border: "2px solid #00f2ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "800",
    boxShadow: "0 0 20px rgba(0,242,255,0.5)"
  },

  android: {
    left: "-20px",
    top: "60px"
  },

  ios: {
    right: "-20px",
    top: "60px"
  },

  shield: {
    position: "absolute",
    inset: 0,
    margin: "auto",
    width: "110px",
    height: "110px",
    borderRadius: "50%",
    background: "rgba(0,242,255,0.12)",
    border: "2px solid #00f2ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "40px",
    boxShadow: "0 0 30px rgba(0,242,255,0.6)",
    animation: "pulseShield 2s ease-in-out infinite"
  },

  title: {
    fontSize: "48px",
    marginBottom: "10px",
    color: "#00f2ff",
    textShadow: "0 0 20px rgba(0,242,255,0.7)"
  },

  subtitle: {
    fontSize: "20px",
    color: "#d8fbff",
    marginBottom: "30px"
  },

  steps: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    flexWrap: "wrap"
  },

  step: {
    padding: "10px 16px",
    borderRadius: "999px",
    background: "rgba(0,242,255,0.1)",
    border: "1px solid rgba(0,242,255,0.3)",
    fontWeight: "700"
  }
};
